import React from 'react';
import styles from './flag.scss';
export const Flag = _ref => {
  let {
    longCountryCode
  } = _ref;
  const flag1x = getFlagUrl(longCountryCode, '1x');
  const flag2x = getFlagUrl(longCountryCode, '2x');
  return /*#__PURE__*/React.createElement("img", {
    src: flag1x,
    srcSet: `${flag1x} 1x, ${flag2x} 2x`,
    alt: "",
    "aria-hidden": "true",
    loading: "lazy",
    className: styles.flag
  });
};
function getFlagUrl(longCountryCode, size) {
  const baseUrl = 'https://static.parastorage.com/services/linguist-flags/1.961.0/assets/flags/square/';
  const suffix = size === '2x' ? '_2x' : '';
  const file = `${longCountryCode}${suffix}.png`;
  return `${baseUrl}${file}`;
}
//# sourceMappingURL=flag.js.map